import { render, staticRenderFns } from "./sk-checkbox-img-wap.vue?vue&type=template&id=33d0b5a4&scoped=true&"
import script from "./sk-checkbox-img-wap.vue?vue&type=script&lang=js&"
export * from "./sk-checkbox-img-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-checkbox-img-wap.vue?vue&type=style&index=0&id=33d0b5a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0b5a4",
  null
  
)

export default component.exports